export const experience = [
  {
    company_name: "Accenture",
    position: "Associate software engineer",
    duration: "October 2023 – Present",
    c_logo: "/images/company/acc.png",
    key_points: [
      "Completed rigorous full-stack training in MongoDB, Express, React, and Node.js with assessments scoring above 75%.",
      "Developed a pizza ordering app with strong validations using JavaScript, React, MongoDB, and Express.",
      "Proficient in React, Angular, Node.js, Express, Bootstrap, and MongoDB after intensive training.",
      "Translated theoretical knowledge into practical solutions, maintaining high coding and project execution standards.",
    ],
  },
  {
    company_name: "Crowd-analytix",
    position: "Intern-frontend developer",
    duration: "January 2023 – May 2023",
    c_logo: "/images/company/ca.jpg",
    key_points: [
      "Proficient in Angular framework, implementing modules, templates,lazy-loading, and API integration for efficient web development.",
    ],
  },
  {
    company_name: "Face-prep",
    position: "Intern-full stack developer",
    duration: "August 2022-October 2022",
    c_logo: "/images/company/fp.jpeg",
    key_points: [
      "Acquired proficiency in Next.js and TypeScript, leveraging these technologies to develop the front end of a slot booking web application for quizzes.",
      "Utilized Express.js for backend development and MongoDB as the database, creating robust backend APIs for seamless slot booking functionality.",
      "Implemented OTP verification during user registration, enhancing security measures and ensuring a trusted user base.",
      "Migrated the auth from the previous version to Oauth 2.0 for goto-webinar api.",
      "Handled version control with help of Bitbucket and used Sourcetree for the git visualization.",
    ],
  },
  {
    company_name: "Kylo-apps",
    position: "React developer intern",
    duration: "May 2022–July 2022",
    c_logo: "/images/company/ka.jpg",
    key_points: [
      "Developed a responsive frontend app with React.js for property renting and buying.",
      "Integrated Google Maps API to enhance property location visualization and user engagement.",
      "Implemented real-time chat functionality to facilitate direct communication within the app.",
      "Collaborated with backend team to seamlessly integrate property data from the server.",
      "Integrated Razorpay payment gateway for secure and seamless transactions within the app.",
    ],
  },
  {
    company_name: "Geekster",
    position: "Educator intern",
    duration: "March 2022 – May 2022",
    c_logo: "/images/company/g.png",
    key_points: [
      "Collaborated with Teachers and made 10-15 topic-wise projects to help students learn better.",
      "Maintained a doubt channel to help 100+ students in solving their queries.",
    ],
  },
];

export const skills = [
  {
    name: "React.js",
    image: "/images/skills/react.png",
  },
  {
    name: "Angular",
    image: "/images/skills/angular.png",
  },
  {
    name: "Next.js",
    image: "/images/skills/next.png",
  },
  {
    name: "Typescript",
    image: "/images/skills/ts.png",
  },
  {
    name: "Express",
    image: "/images/skills/express.webp",
  },
  {
    name: "Html, Css and Javascript",
    image: "/images/skills/hcj.png",
  },
  {
    name: "MongoDB",
    image: "/images/skills/mongo.png",
  },
];

export const projects = [
  {
    name: "Madhav-IDE",
    desc: "Developed a feature-rich online IDE supporting 15+ programming languages, utilizing Express.js as the backend framework and MongoDB for code storage.",
    links: {
      live: "",
      github: "https://github.com/madhav592001/Madhav-IDE",
      youtube: "",
    },
    technologies: [
      "React.js",
      "express",
      "Jdoodle API",
      "monaco-editor",
      "mongoDB",
    ],
    image: "images/projects/mide.png",
  },
  {
    name: "Blog-it",
    desc: "Developed a feature-rich blog application allowing users to create, update, delete, and view blog posts, leveraging Express.js for the backend API implementation.",
    links: {
      live: "",
      github: "https://github.com/madhav592001/University_Blogs",
      youtube: "",
    },
    technologies: [
      "React.js",
      "Bootstrap",
      "Express",
      "jsonwebtoken",
      "MongoDB",
    ],
    image: "images/projects/blog-it.png",
  },
  {
    name: "User management",
    desc: "User management system using local storage",
    links: {
      live: "https://user-management-angular.netlify.app",
      github: "https://github.com/madhav592001/CA-Task1",
      youtube: "",
    },
    technologies: ["Angular", "Bootstrap", "Typescript"],
    image: "images/projects/um.png",
  },
  {
    name: "Avail-info",
    desc: "Information portal for users of hospitals posting their facilities, doctor information.",
    links: {
      live: "",
      github: "https://github.com/madhav592001/S.A.M",
      youtube: "https://www.youtube.com/watch?v=l2u97lB6tkk",
    },
    technologies: [
      "React.js",
      "Express",
      "jsonwebtoken",
      "MongoDB",
      "Nodemailer",
    ],
    image: "images/projects/ai.jpeg",
  },
];
